export enum ApplicationSummaryType {
  DASHBOARD_LIVE = 'dashboard-live',
  DASHBOARD_HISTORIC = 'dashboard-historic',
  LIVE = 'live',
  HISTORIC = 'historic',
}

export type ApplicationSummaryItem = {
  assessment__Id: number;
  assessment__IsAssessmentSubmitted: boolean;
  assessment__Summary?: { Overall: number; Steps: StageStep[] };
  client__ClientName: string;
  project__Id: string;
  project__Title: string;
  application__Status: string;
  jobApplication__ID: number;
  jobApplication__IsApplicationComplete: boolean;
  isAssessmentOnlyProject?: boolean;
};

export type ConnectionsCarouselItem = {
  hiringManagerSearchCandidateInterest__Id: number;
  hiringManagerSearchCandidateInterest__CandidateInterest: boolean | null;
  hiringManagerSearchCandidateInterest__HiringManagerInterest: boolean;
  hiringManagerSearch__Id: number;
  hiringManagerSearch__Title: string | null;
  hiringManager__FullName: string;
};

export type ApplicationJobInterviewItem = {
  event__ID: number;
  event__Title: string;
  event__Interviewer?: string;
  event__Date: string;
  event__Date__End: string;
  event__Joined: boolean;
  event__Cancelled?: boolean;
  event__Available?: boolean;
  event__HiringManagerCancelled: boolean;
  event__IsInterview: boolean;
};

export type ApplicationSummaryDashboardProps = {
  type: ApplicationSummaryType;
  data: ApplicationSummaryItem;
};
export type ApplicationSummaryProps = {
  type: ApplicationSummaryType;
  data: ApplicationSummaryBaseProps;
};
export type ApplicationSummaryBaseProps = {
  id: number;
  projectId: number;
  progress: number;
  title: string;
  jobType: string;
  workSchedule: string;
  salary: string | null;
  place: string;
  company: string;
  currency: string;
  stages: any;
  historic: boolean;
  applicationType: string;
  isApplicationFormComplete: boolean;
  jobApplicationId: number;
};
export type ApplicationSummaryDashboardLiveProps = {
  id: number;
  status: string;
  summary?: { Overall: number; Steps: StageStep[] };
  company: string;
  jobTitle: string;
  applicationType: string;
  projectId: string;
  isApplicationFormComplete: boolean;
  jobApplicationId: number;
  isAssessmentOnlyProject?: boolean;
};
export type ApplicationSummaryDashboardHistoricProps = {
  id: number;
  status: string;
  company: string;
  jobTitle: string;
  applicationType: string;
  projectId: string;
  progress: number;
  jobApplicationId: number;
};

export type StageStep = {
  StepName: string;
  Percentage: number;
  Result: string;
};
